import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor() { }

  login() {
    return gql`
      mutation login ($input: UsersPermissionsLoginInput!) {
        login (input: $input) {
          jwt
          user{
            id
          }
        }
      }
    `;
  }

  getUserToken(){   
    return JSON.parse(sessionStorage.getItem('token') || '{}')
  }

  setUserToken(token: any){
    sessionStorage.setItem('token', JSON.stringify(token))
    //sessionStorage.setItem('token', token)
  }

  removeUserStorage(){
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
  }

  getUserData(){   
    return JSON.parse(sessionStorage.getItem('user') || '{}')
  }

  setUserData(user: any){
    sessionStorage.setItem('user', JSON.stringify(user))
  }

  updateUserData(user: any){
    sessionStorage.removeItem('user');
    sessionStorage.setItem('user', JSON.stringify(user))
  }
}
